// EdgeSwipeBackIndicator — Indicador visual "◀" que sigue el dedo cuando se
// arrastra desde el borde izquierdo. Se oculta si dragX es 0. Alto z-index.
import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { useEdgeSwipeBack } from '../hooks/useEdgeSwipeBack';

const EdgeSwipeBackIndicator = ({ enabled = true }) => {
  const { dragX } = useEdgeSwipeBack({ enabled });
  if (dragX <= 0) return null;
  const opacity = Math.min(1, dragX / 100);
  const translate = Math.min(dragX * 0.5, 60);
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        top: '50%',
        left: 0,
        transform: `translate(${translate}px, -50%)`,
        pointerEvents: 'none',
        zIndex: 9999,
        opacity,
        transition: 'opacity 60ms linear',
      }}
      data-testid="edge-swipe-back-indicator"
    >
      <div
        className="rounded-full bg-black/70 border border-white/25 shadow-lg flex items-center justify-center"
        style={{ width: 44, height: 44, backdropFilter: 'blur(8px)' }}
      >
        <ChevronLeft className="w-6 h-6 text-white" />
      </div>
    </div>
  );
};

export default EdgeSwipeBackIndicator;
